import ContentSearch from '../components/content-search';

export default class ContentSearchFlyoutController {
  /* @ngInject */
  constructor($scope) {
    $scope.ContentSearch = ContentSearch;
  }
}
